/**
 * Copyright © 2021-2022 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */

import { DAIGroupEnum } from '@dai/graphql'

export const AUDIT_USERS = [
  DAIGroupEnum.RED_ADMINS,
  DAIGroupEnum.RED_MANAGERS,
  DAIGroupEnum.AUDITORS,
]

export const PICOS_USERS = [DAIGroupEnum.PICOS]
